import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import ButtonPrimary, {
  EButtonSize,
} from "@rentiohq/shared-frontend/dist/components/components/ButtonPrimary";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import * as S from "./InfoHeader.styles";
import { EInfoHeaderStyle } from "./InfoHeader.types";

interface IProps {
  title: string | JSX.Element;
  titleStyle?: EInfoHeaderStyle;
  body?: string | JSX.Element;
  largeButton?: boolean;
  buttonTitle?: string;
  onPressButton?: () => void;
}

class InfoHeader extends React.Component<IProps> {
  // Render
  public render() {
    const { title, body, titleStyle } = this.props;
    return (
      <S.Wrap>
        <S.Title titleStyle={titleStyle}>{title}</S.Title>
        <S.Body>{body}</S.Body>
        {this.renderButton()}
      </S.Wrap>
    );
  }

  private renderButton = () => {
    const { largeButton = false, buttonTitle, onPressButton } = this.props;
    if (!buttonTitle) {
      return;
    }

    if (largeButton) {
      return (
        <S.ButtonPrimaryWrap>
          <ButtonPrimary
            title={getLocalizedText(buttonTitle)}
            onPress={onPressButton}
            buttonSize={EButtonSize.Large}
          />
        </S.ButtonPrimaryWrap>
      );
    }

    return (
      <S.ButtonBasicWrap>
        <ButtonBasic
          title={getLocalizedText(buttonTitle)}
          onPress={onPressButton}
        />
      </S.ButtonBasicWrap>
    );
  };
}

// eslint-disable-next-line import/no-default-export
export default InfoHeader;
